module.exports = __webpack_public_path__ + "static/img/footerImg01.4eec684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footerImg01.png
// module id = MMF9
// module chunks = 22